import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import uniqBy from 'lodash.uniqby';
import { useLocations } from './useLocations';

export const useSurveysOptions = () => {
    const surveys = useSelector(state => state.surveys.data);

    const { locationsMap } = useLocations();

    const getSurveysByLocationIds = useCallback(
        locationsIds => {
            return [
                ...new Set(
                    locationsIds
                        .map(id => locationsMap[id])
                        .filter(Boolean)
                        .map(company => company.surveys)
                        .flat()
                        .map(survey => survey.id),
                ),
            ];
        },
        [locationsMap],
    );

    const mapSurveyPropsToOption = survey => ({
        value: survey.id,
        label: survey.name,
        message: survey.message,
    });

    const getSurveysOptionsByBrand = useCallback(
        brandId => {
            return surveys.filter(s => s.survey.brandId === brandId).map(item => mapSurveyPropsToOption(item.survey));
        },
        [surveys],
    );

    const getSurveysOptionsByLocation = useCallback(
        (locationId, propsMapper = mapSurveyPropsToOption) => {
            const location = locationsMap[locationId];
            if (!location) return [];

            const surveys = location.surveys.map(propsMapper);
            return uniqBy(surveys, 'value');
        },
        [locationsMap],
    );

    const getBrandSurveysOptionsByIds = useCallback(
        (locationsIds, propsMapper = mapSurveyPropsToOption) => {
            return uniqBy(
                locationsIds
                    .map(id => locationsMap[id])
                    .filter(Boolean)
                    .map(company => company.surveys)
                    .flat()
                    .map(propsMapper),
                'value',
            );
        },
        [locationsMap],
    );

    return {
        getBrandSurveysOptionsByIds,
        getSurveysOptionsByLocation,
        getSurveysByLocationIds,
        getSurveysOptionsByBrand,
    };
};
